<template>
    <Alert type="warning" show-icon>
        A warning prompt
        <template slot="desc">
            Content of prompt. Content of prompt. Content of prompt.
        </template>
    </Alert>
</template>

<script>
    export default {
    }
</script>
